import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import {
    GET_CUSTOMER_LISTING,
    GET_CUSTOMER_DETAILS,
    UPDATE_CUSTOMER,
    CUSTOMER_ACTIVATION,
    GET_CUSTOMER_HISTORY_LISTING,
    DELETE_CUSTOMER,
    EXPORT_CUSTOMER_LISTING,
    SWITCH_CUSTOMER_DOCTOR,
    CREATE_CUSTOMER,
    GET_CUSTOMER_ORDERS_LISTING,
} from "./actionTypes.js";

import {
    getCustomerListingSuccess,
    getCustomerListingFail,
    getCustomerDetailsSuccess,
    getCustomerDetailsFail,
    updateCustomerSuccess,
    updateCustomerFail,
    customerActivationSuccess,
    customerActivationFail,
    getCustomerHistorySuccess,
    getCustomerHistoryFail,
    deleteCustomerSuccess,
    deleteCustomerFail,
    exportCustomerListingSuccess,
    exportCustomerListingFail,
    switchCustomerDoctorSuccess,
    switchCustomerDoctorFail,
    createCustomerSuccess,
    createCustomerFail,
    getCustomerOrderListingSuccess,
    getCustomerOrderListingFail,
} from "./actions.js";

import {
    getCustomerDetailsApi,
    editCustomerApi,
    customerActivationApi,
    getCustomerHistoryApi,
    deleteCustomerApi,
    exportCustomerListingApi,
    switchCustomerApi,
    customerListingApi,
    createCustomerApi,
    getCustomerOrdersApi,
} from "./customerApi.js";

function* fetchCustomerListing({ payload }) {
    try {
        const response = yield call(customerListingApi, payload);
        yield put(getCustomerListingSuccess(response));
    } catch (error) {
        yield put(getCustomerListingFail(error));
    }
}

function* fetchCustomerDetails({ payload }) {
    try {
        const response = yield call(getCustomerDetailsApi, payload);
        yield put(getCustomerDetailsSuccess(response));
    } catch (error) {
        yield put(getCustomerDetailsFail(error));
    }
}

function* createCustomer({ payload }) {
    try {
        const response = yield call(createCustomerApi, payload);
        yield put(createCustomerSuccess(response));
    } catch (error) {
        yield put(createCustomerFail(error));
    }
}

function* updateCustomer({ payload }) {
    try {
        const response = yield call(editCustomerApi, payload);
        yield put(updateCustomerSuccess(response));
    } catch (error) {
        yield put(updateCustomerFail(error));
    }
}

function* activateCustomer({ payload }) {
    try {
        const response = yield call(customerActivationApi, payload);
        yield put(customerActivationSuccess(response));
    } catch (error) {
        yield put(customerActivationFail(error));
    }
}

function* fetchCustomerHistory({ payload }) {
    try {
        const response = yield call(getCustomerHistoryApi, payload);
        yield put(getCustomerHistorySuccess(response));
    } catch (error) {
        yield put(getCustomerHistoryFail(error));
    }
}

function* fetchCustomerOrders({ payload }) {
    try {
        const response = yield call(getCustomerOrdersApi, payload);
        yield put(getCustomerOrderListingSuccess(response));
    } catch (error) {
        yield put(getCustomerOrderListingFail(error));
    }
}

function* deleteCustomer({ payload }) {
    try {
        const response = yield call(deleteCustomerApi, payload);
        yield put(deleteCustomerSuccess(response));
    } catch (error) {
        yield put(deleteCustomerFail(error));
    }
}

function* exportCustomerListing({ payload }) {
    try {
        const response = yield call(exportCustomerListingApi, payload);
        yield put(exportCustomerListingSuccess(response));
    } catch (error) {
        yield put(exportCustomerListingFail(error));
    }
}

function* switchCustomerDoctor({ payload }) {
    try {
        const response = yield call(switchCustomerApi, payload);
        yield put(switchCustomerDoctorSuccess(response));
    } catch (error) {
        yield put(switchCustomerDoctorFail(error));
    }
}

function* CustomerSaga() {
    yield takeEvery(GET_CUSTOMER_LISTING, fetchCustomerListing);
    yield takeEvery(GET_CUSTOMER_DETAILS, fetchCustomerDetails);
    yield takeEvery(CREATE_CUSTOMER, createCustomer);
    yield takeEvery(UPDATE_CUSTOMER, updateCustomer);
    yield takeEvery(CUSTOMER_ACTIVATION, activateCustomer);
    yield takeEvery(GET_CUSTOMER_HISTORY_LISTING, fetchCustomerHistory);
    yield takeEvery(GET_CUSTOMER_ORDERS_LISTING, fetchCustomerOrders);
    yield takeEvery(DELETE_CUSTOMER, deleteCustomer);
    yield takeEvery(EXPORT_CUSTOMER_LISTING, exportCustomerListing);
    yield takeEvery(SWITCH_CUSTOMER_DOCTOR, switchCustomerDoctor);
}

export default CustomerSaga;